import {receipts,uploaded,downloaded,clearReceipts,forgetUpload,verifiedUpload} from './assetReceipts';
import {useAccount} from '../store/account';
import {hasLocalPhoto} from './media';
import { apiFetch as fetch } from './sessionInstance';
import type { MediaRef } from '../types';
import { localMediaData, cacheRemotePhoto,deletePhoto } from './media';
import { ApiError } from './auth';
const pending=new Map<string,Promise<MediaRef>>();
export async function backupPhoto(
  ref: MediaRef,
  account: string,
): Promise<MediaRef> {
  if (!ref.uri.startsWith('idb:') && !ref.uri.startsWith('data:image/'))
    return ref;
  let id = receipts(account).uploaded[ref.uri];
  if(id&&(receipts(account).verified?.[id]??0)<Date.now()-6*86400_000){
    const response=await fetch(`/api/assets/${id}`,{method:'HEAD',credentials:'same-origin'});
    if(response.status===404){forgetUpload(account,ref.uri);id='';}
    else if(!response.ok)throw new ApiError('backup_check_failed');
    else verifiedUpload(account,id);
  }
  if (!id) {
    const data = ref.uri.startsWith('data:')
      ? ref.uri
      : await localMediaData(ref);
    if (!data.startsWith('data:image/')) throw new ApiError('bad_image');
    const response = await fetch('/api/assets', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ body: data.slice(data.indexOf(',') + 1) }),
    });
    const result = (await response.json()) as { id: string; error?: string };
    if (!response.ok) throw new ApiError(result.error ?? 'backup_failed');
    id = result.id;
    uploaded(account,ref.uri,id);
  }
  return { ...ref, uri: `chefi-asset:${id}` };
}
/** A cloud reference is already portable. Rendering fetches its image progressively. */
export async function restorePhoto(ref:MediaRef,account:string):Promise<MediaRef>{
  if(!ref.uri.startsWith('chefi-asset:'))return ref;
  const cached=receipts(account).downloaded[ref.uri.slice(12)];
  return cached&&await hasLocalPhoto(cached)?{...ref,...cached}:ref;
}
export async function downloadPhoto(ref:MediaRef):Promise<MediaRef>{
  const account=useAccount.getState().user?.id;
  if(!account)throw new Error('not_signed_in');
  const cached=await restorePhoto(ref,account);if(cached.uri!==ref.uri)return cached;
  const id=ref.uri.slice(12),key=`${account}:${id}`;
  const old=pending.get(key);if(old)return old;
  const work=(async()=>{
    const saved=await cacheRemotePhoto({uri:`/api/assets/${id}`},ref.mimeType);
    if(useAccount.getState().user?.id!==account){await deletePhoto(saved);throw new Error('account_changed');}
    downloaded(account,id,saved);return {...ref,...saved};
  })().finally(()=>pending.delete(key));pending.set(key,work);return work;
}
export function clearBackupCache():void{clearReceipts();}
